import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconConsoleSimple1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"console-simple, terminal"} maskId="square-filled-radius-0-stroke-1-IconConsoleSimple1"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM6.5 7.04289L8.95711 9.5L6.5 11.9571L5.79289 11.25L7.54289 9.5L5.79289 7.75L6.5 7.04289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconConsoleSimple1;
